import {List} from "@material-ui/core";
import Song from "./Song"
import SongActionButton from "../VotingQueue/SongActionButton";
import React from "react";
import {getState} from "../../../controllers/stateController";

function SongQueue({queue, handleVote, hasVotedAlready, handleRemove}) {

  return (
    <List id="songQueue">
      {queue.map((song, i) => {
        return <Song track={song} key={song.title} action={getState().role === "host"
            ? <SongActionButton
                song={song}
                handleRemove={(s) => handleRemove(s)}
                canVote={false}
            />
            : null}
        />
      })}
    </List>
  );
}
export default SongQueue;
